module.exports = __webpack_public_path__ + "static/media/video-1.fd18a9a4.jpg";